import { useMemo, useReducer } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import CustomersContext from './CustomersContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const CustomersProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <CustomersContext.Provider value={{ actions, selectors, state }}>
      {children}
    </CustomersContext.Provider>
  );
};

export default CustomersProvider;
